import React, { useState } from 'react'
import axios from 'axios';
import Main from './Main'
import firebase from "firebase/app";
//toast
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import mailvalidator from './Config/mailvalidator';

function Contact() {

    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [subject, setSubject] = useState("");
    const [msg, setMsg] = useState("");
    const [sendStatus, setSendStatus] = useState(false);

    const addContactDetails = async () => {
        const contactId = new Date().getTime();
        if (name.trim() === "") {
            toast('Please put name !', {
                type: "error",
            });
        } else if (email.trim() === "") {
            toast('Please put email !', {
                type: "error",
            });
        } else if (subject.trim() === "") {
            toast('Please put subject !', {
                type: "error",
            });
        } else if (msg.trim() === "") {
            toast('Please put message !', {
                type: "error",
            });
        } else {
            setSendStatus(true);
            const regexForEmail = /\S+@\S+\.\S+/;
            try {
                const emailValidationDetails = await axios.get(`${mailvalidator}&email=${email}&format=1`);
                if (emailValidationDetails.status === 200 && emailValidationDetails.data && emailValidationDetails.data.format_valid && emailValidationDetails.data.smtp_check) {
                    firebase.database().ref('Contact/' + contactId).set({
                        name,
                        email,
                        subject,
                        msg
                    })
                    toast('Thank you for contacting me !', {
                        type: "success",
                    });
                    setName("");
                    setEmail("");
                    setSubject("");
                    setMsg("");
                    setSendStatus(false);
                } else if (regexForEmail.test(email)) {
                    firebase.database().ref('Contact/' + contactId).set({
                        name,
                        email,
                        subject,
                        msg
                    })
                    toast('Thank you for contacting me from else !', {
                        type: "success",
                    });
                    setName("");
                    setEmail("");
                    setSubject("");
                    setMsg("");
                    setSendStatus(false);
                } else {
                    toast('Email is invalid or not exist', {
                        type: "error",
                    });
                    setSendStatus(false);
                }
            } catch (e) {
                toast('Oops something went wrong !', {
                    type: "error",
                });
                setSendStatus(false);
            }
        }
    }

    return (
        <>
            <Main active="contact">
                <ToastContainer />
                <div className="main">
                    <section id="contact" className="contact" style={{ paddingBottom: "25px" }}>
                        <div className="container">

                            <div className="section-title">
                                <h2>Contact</h2>
                                <p style={{ "fontSize": "18px" }}>Interested in hiring me for your project or just want to say hi? You can fill in the contact form below or send me an email.</p>
                            </div>

                            <div className="row">
                                <div className="col-lg-5 d-flex align-items-stretch">
                                    <div className="info">
                                        <div className="address">
                                            <i className="bx bx-current-location"></i>
                                            <h4>Location:</h4>
                                            <p>Near Durgamandir, Ushagram, Asansol - 713303, West Bengal</p>
                                        </div>

                                        <div className="email">
                                            <i className="bx bx-envelope"></i>
                                            <h4>Email:</h4>
                                            <p>barunpandey402@gmail.com</p>
                                        </div>

                                        <div className="phone">
                                            <i className="bx bx-phone"></i>
                                            <h4>Call:</h4>
                                            <p>7001665817</p>
                                        </div>

                                    </div>

                                </div>

                                <div className="col-lg-7 mt-5 mt-lg-0 info">
                                    <div className="form-row">
                                        <div className="form-group col-md-6">
                                            <label htmlFor="name">Your Name<sup style={{ "color": "red" }}>*</sup></label>
                                            <input type="text" name="name" value={name} onChange={(e) => setName(e.target.value)} className="form-control" id="name" />
                                            <div className="validate"></div>
                                        </div>
                                        <div className="form-group col-md-6">
                                            <label htmlFor="name">Your Email<sup style={{ "color": "red" }}>*</sup></label>
                                            <input type="email" className="form-control" value={email} onChange={(e) => setEmail(e.target.value)} name="email" id="email" />
                                            <div className="validate"></div>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="name">Subject<sup style={{ "color": "red" }}>*</sup></label>
                                        <input type="text" className="form-control" value={subject} onChange={(e) => setSubject(e.target.value)} name="subject" id="subject" />
                                        <div className="validate"></div>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="name">Message<sup style={{ "color": "red" }}>*</sup></label>
                                        <textarea className="form-control" name="message" value={msg} onChange={(e) => setMsg(e.target.value)} rows="4"></textarea>
                                        <div className="validate"></div>
                                    </div>
                                    <div className="text-center"><button type="button" className="btn btn-primary" disabled={sendStatus} title={sendStatus ? "Please wait ..." : ""} onClick={addContactDetails}>Send Message</button></div>
                                </div>

                            </div>

                        </div>
                    </section>
                </div>
            </Main>
        </>
    )
}

export default Contact
